module.exports = __webpack_public_path__ + "img/element-4.d89c459d.svg";